import { render, staticRenderFns } from "./FunctionalArea.vue?vue&type=template&id=87f65b7c&scoped=true&"
import script from "./FunctionalArea.vue?vue&type=script&lang=js&"
export * from "./FunctionalArea.vue?vue&type=script&lang=js&"
import style0 from "./FunctionalArea.vue?vue&type=style&index=0&id=87f65b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f65b7c",
  null
  
)

export default component.exports